<app-menu>
    <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine" [columnDefs]="cartonColumnDefs"
         (gridReady)="onGridReady($event)" [defaultColDef]="defaultColDef" [gridOptions]="gridOptions"
        #agGrid></ag-grid-angular>
</app-menu>>